export const KEYS = {
    AUTH_KEY: 'accessToken',
    REFRESH_KEY: 'refreshToken',
    RECOIL_KEY: 'recoil-persist',
    LOGIN_ID: 'loginId',
    ID_SAVE: 'idSave',
    SPACE_NAME: 'spaceName',
    BRAND_CODE: 'brandCode',
    SELECT_SHOP_ID: 'selectShopId',
    SHOP_COPY: 'shopCopy',
    MEMBER_BRAND_URL: 'memberBrandUrl',
    ATOM: {
        spaceName: 'spaceName',
        userState: 'userState',
        spaceState: 'spaceState',
        brandState: 'brandState',
        memberState: 'memberState',
        shopState: 'shopState',
        playerType: 'playerType',
        templateType: 'templateType',
        loadingState: 'loadingState',
        mainMenuState: 'mainMenuState',
        shopCopyState: 'shopCopyState',
        accessModalState: 'accessModalState',
    },
    QUERY: {
        login: {
            admin: 'loginCall',
            token: 'tokenCall',
            kraftonSSO: 'kraftonSSOCall'
        },
        member: {
            me: 'memberMeCall',
            singUp: 'memberSingUpCall',
            list: 'memberListCall',
            detail: 'memberDetailCall',
            edit: 'memberEditCall',
            inviteList: 'memberInviteListCall',
            inviteInfo: 'memberInviteInfo',
            shopInviteInfo: 'memberShopInviteInfo',
            roleList: 'memberRoleList',
            remove: 'memberRemoveCall',
            passwordChange: 'memberPasswordChangeCall',
            placeChange: 'memberPlaceChangeCall'
        },
        space: {
            list: 'spaceListCall',
            brand: 'spaceBrandCall',
            item: 'spaceItemCall',
            popup: 'spacePopupCall',
            target: 'spaceTargetCall',
            allList: 'spaceAllListCall',
            brandShop: 'spaceBrandShopCall',
            shopCopyProgress: 'shopCopyProgress'
        },
        brand: {
            list: 'brandListCall',
            detail: 'brandDetailCall',
            detailByCode: 'brandDetailByCodeCall',
        },
        company: {
            list: 'companyListCall',
            listByShop: 'companyListByShopCall',
            detail: 'companyDetailCall',
            name: 'companyNameCall'
        },
        externalService: {
            list: 'externalServiceListCall',
            detail: 'externalServiceDetailCall',
        },
        board: {
            noticeList: 'noticeListCall',
            noticeDetail: 'noticeDetailCall',
            list: 'boardListCall',
            detail: 'boardDetailCall',
        },
        satisfaction: {
            mobile: {
                data: 'satisfactionMobileDataCall',
                participantList: 'satisfactionMobileParticipantListCall',
                listExcel: 'satisfactionMobileListExcelCall',
                participantItemList: 'satisfactionMobileParticipantItemListCall',
                participantItemGraph: 'satisfactionMobileParticipantItemGraphCall',
                itemExcel: 'satisfactionMobileItemExcelCall',
                tagList: 'satisfactionMobileTagListCall'
            },
            kiosk: {
                data: 'satisfactionKioskDataCall',
                menuList: 'satisfactionKioskMenuListCall',
                participantList: 'satisfactionKioskParticipantListCall',
                listExcel: 'satisfactionKioskParticipantListExcelCall',
                participantRankList: 'satisfactionKioskParticipantRankListCall',
                participantItemList: 'satisfactionKioskParticipantItemListCall',
                participantItemGraph: 'satisfactionKioskParticipantItemGraphCall',
                itemExcel: 'satisfactionKioskParticipantItemExcelCall',
            }
        },
        config: {
            list: 'configListCall',
            groupList: 'configGroupListCall',
            code: {
                list: 'codeListCall',
                groupList: 'codeGroupListCall',
            },
            properties: {
                list: 'propertiesListCall'
            },
            enum: 'enumListCall',
        },
        delivery: {
            list: 'deliveryListCall',
            zone: 'deliveryZoneCall',
            pickup: 'reservedPickupCall',
            zoneList: 'deliveryZoneListCall',
            robot: {
                zoneList: 'robotZoneListCall',
                zone: 'robotZoneCall',
                deliveryList: 'robotDeliveryListCall',
                deliveryKmList: 'robotDeliveryKmListCall'
            }
        },
        shop: {
            detail: 'shopInfoCall',
            list: 'shopListCall',
            name: 'shopNameCall',
            type: 'shopTypeCall',
            config: 'shopAllConfigCall',
            listIds: 'shopListIdsCall',
            salesActionList: 'shopSalesActionListCall',
            salesPlanCafe: 'shopSlesPlanCafe',
            salesPlanCafeBreakTime: 'shopSalesPlanCafeBreakTimeCall',
            salesPlanCafeteria: 'shopSalesPlanCafeteriaCall'
        },
        goods: {
            list: 'goodsListCall',
            listPos: 'goodsListPosCall',
            detailList: 'goodsDetailListCall',
            detail: 'goodsDetailCall',
            displayList: 'goodsDisplayListCall',
            displaySortList: 'goodsDisplaySortListCall',
            displayData: 'goodsDisplayDataCall',
            stockList: 'goodsStockListCall',
            stock: 'goodsStockCall',
            stockLog: 'goodsStockLogCall',
            optionList: 'goodsOptionListCall',
            option: 'goodsOptionCall',
            optionSelectList: 'goodsOptionSelectListCall',
            categoryList: 'goodsCategoryListCall',
            groupList: 'goodsGroupListCall',
            groupNoPagingList: 'goodsGroupNoPagingListCall',
            orderManage: 'goodsOrderManageCall',
            orderStatus: 'goodsOrderStatusCall',
            previousStatic: 'goodsPreviousStaticCall',
            lastSalesStatic: 'goodsLastSalesStaticCall',
            paymentList: 'goodsPaymentListCall',
            payment: 'goodsPayment'
        },
        category: {
            list: 'categoryListCall',
            menuList: 'categoryMenuListCall',
            add: 'categoryAddCall',
            listAdd: 'categoryListAddCall',
            update: 'categoryUpdateCall',
            remove: 'categoryRemoveCall',
            changeTrafficLight: 'categoryChangeTrafficLightCall',
            reOrder: 'categoryReOrderCall',
            group: {
                list: 'categoryGroupListCall',
                edit: 'categoryGroupListEdit'
            }
        },
        customer: {
            list: 'customerListCall',
            count: 'customerListCountCall',
            log: 'customerListLog',
            brandLog: 'customerBrandLogCall',
            simple: 'customerListSimpleCall',
            external: {
                list: 'customerExternalListCall',
                detail: 'customerExternalDetailCall',
                modAt: 'customerExternalModAtCall',
                count: 'customerExternalCountCall',
                rfid: 'customerExternalRfidCall',
            }
        },
        device: {
            list: 'deviceListCall',
            detail: 'deviceDetailCall',
            groupList: 'deviceGroupListCall',
            contentList: 'deviceContentListCall',
            content: 'deviceContentCall',
            contentShopTemplate: 'deviceContentShopTemplateCall',
            contentsDeployDeviceList: 'contentsDeployDeviceListCall',
            contentsDeployContentsList: 'contentsDeployContentsListCall',
            screenLogList: 'screenLogListCall',
            screenLogForDetailList: 'screenLogForDetailListCall',
            countByBrand: 'countByBrand',
            remote: 'deviceRemoteCall',
            contentDiningCourse: 'deviceContentDiningCourseListCall',
            listByShop: 'deviceListByShopCall',
            vnc: {
                list: 'deviceVncListCall',
                duplicated: 'deviceVncDuplicatedCall',
                info: 'deviceVncInfoCall',
            }
        },
        manual: {
            list: 'manualListCall',
            detail: 'manualDetailCall',
            serviceIntro: 'manualServiceIntoCall',
        },
        terms: {
            list: 'termsListCall',
            detail: 'termsDetailCall'
        },
        meal: {
            list: 'mealListCall',
            operationTimeList: 'mealOperationTimeList',
            course: 'mealCourseCall',
            courseDate: 'mealCourseDateCall',
        },
        menu: {
            list: 'menuListCall',
            subList: 'menuSubListCall',
            roleList: 'menuRoleListCall'
        },
        payment: {
            list: 'paymentListCall',
            detail: 'paymentDetailCall',
            mealDetail: 'paymentMealDetailCall',
            reason: {
                list: 'paymentReasonListCall',
                detail: 'paymentReasonDetailCall'
            }
        },
        scheduler: {
            list: 'schedulerListCall'
        },
        storage: {
            list: 'storageListCall',
            add: 'storageAddCall',
            edit: 'storageEditCall',
            remove: 'storageRemoveCall',
            attach: 'storageAttachCall'
        },
        survey: {
            list: 'surveyListCall',
            detail: 'surveyDetailCall'
        },
        distribute: {
            list: 'distributeListCall',
            fileList: 'distributeFileListCall',
            fileDetail: 'distributeFileDetailCall',
            target: 'distributeTargetCall',
            operating: 'distributeOperatingCall',
            latest: 'distributeLatestCall',
            mobile: 'distributeMobileCall',
        },
        sales: {
            list: 'manualSalesListCall',
            detail: 'manualSalesDetailCall',
            upload: 'manualSalesUploadCall',
            validation: 'manualSalesValidationCall',
            payment: 'manualSalesPaymentCall',
            delete: 'manualSalesDeleteCall',
            excel: 'manualSalesExcelCall',
            etc: 'etcSalesListCall',
            etcExcel: 'etcSalesExcelCall'
        },
        statistics: {
            goods: {
                period: 'statisticsGoodsPeriodCall',
                group: 'statisticsGoodsGroupCall',
                paymentName: 'statisticsGoodsPaymentNameCall',
                orderType: 'statisticsGoodsOrderTypeCall',
                deviceType: 'StatisticsGoodsOrderDeviceTypeCall',
                company: 'statisticsGoodsCompanyCall',
                customer: 'statisticsGoodsCustomerCall',
                list: 'statisticsGoodsListCall'
            },
            meal: {
                period: 'statisticsMealPeriodCall',
                paymentName: 'statisticsMealPaymentNameCall',
                deviceType: 'StatisticsMealOrderDeviceTypeCall',
                operationTime: 'statisticsMealOperationTimeCall',
                company: 'statisticsMealCompanyCall',
                customer: 'statisticsMealCustomerCall',
                list: 'statisticsMealListCall'
            }
        },
        statisticsV2: {
            sales: {
                meal: {
                    calendar: {
                        base: 'statisticsSalesMealCalendar',
                        excel: {
                            sales: 'statisticsSalesMealCalendarExcelSales',
                            operationTime: 'statisticsSalesMealCalendarExcelOpTime',
                        }
                    },
                    item: {
                        bar: {
                            current: 'statisticsSalesMealItemBarCurrent',
                            period: 'statisticsSalesMealItemBarPeriod',
                        },
                        pie: {
                            current: 'statisticsSalesMealItemPieCurrent',
                            period: 'statisticsSalesMealItemPiePeriod',
                        },
                        excel: 'statisticsSalesMealItemExcelPeriod'
                    },
                    customer: {
                        base: 'statisticsSalesMealCustomer',
                        excel: {
                            base: 'statisticsSalesMealCustomerExcel',
                            detail: 'statisticsSalesMealCustomerExcelDetail'
                        }
                    },
                    list: {
                        current: 'statisticsSalesMealListCurrent',
                        period: 'statisticsSalesMealListPeriod',
                        settlement: 'statisticsSalesMealListSettlement',
                        excel: 'statisticsSalesMealListExcel',
                        detail: 'statisticsSalesMealOrderPaymentDetail',
                    }
                },
                goods: {
                    calendar: {
                        base: 'statisticsSalesGoodsCalendar',
                        excel: 'statisticsSalesGoodsCalendarExcel'
                    },
                    item: {
                        bar: {
                            current: 'statisticsSalesGoodsItemBarCurrent',
                            period: 'statisticsSalesGoodsItemBarPeriod',
                        },
                        pie: {
                            current: 'statisticsSalesGoodsItemPieCurrent',
                            period: 'statisticsSalesGoodsItemPiePeriod',
                        },
                        excel: 'statisticsSalesGoodsItemExcelPeriod'
                    },
                    customer: {
                        base: 'statisticsSalesGoodsCustomer',
                        excel: {
                            base: 'statisticsSalesGoodsCustomerExcel',
                            detail: 'statisticsSalesGoodsCustomerExcelDetail'
                        }
                    },
                    list: {
                        current: 'statisticsSalesGoodsListCurrent',
                        period: 'statisticsSalesGoodsListPeriod',
                        excel: 'statisticsSalesGoodsListExcel',
                    }
                }
            },
            goodsSales: {
                goods: {
                    groupRanking: {
                        base: 'statisticsGoodsSalesGoodsGroupRanking',
                        excel: 'statisticsGoodsSalesGoodsGroupRankingExcel',
                    },
                    goodsRanking: {
                        base: 'statisticsGoodsSalesGoodsRanking',
                        excel: 'statisticsGoodsSalesGoodsRankingExcel',
                    },
                    option: {
                        base: 'statisticsGoodsSalesOption',
                        excel: 'statisticsGoodsSalesOptionExcel',
                    },
                    optionType: {
                        excel: 'statisticsGoodsSalesOptionTypeExcel',
                    }
                }
            },
            operation: {
                goods: {
                    operationTime: {
                        current: 'statisticsOperationGoodsOperationTimeCurrent',
                        period: 'statisticsOperationGoodsOperationTimePeriod',
                    },
                    timeSalesTrend: {
                        current: 'statisticsOperationGoodsTimeSalesTrendCurrent',
                        period: 'statisticsOperationGoodsTimeSalesTrendPeriod',
                        excel: 'statisticsOperationGoodsTimeSalesTrendExcel',
                        productGroup: {
                            current: 'statisticsOperationGoodsTimeSalesTrendProductGroupCurrent',
                            period: 'statisticsOperationGoodsTimeSalesTrendProductGroupPeriod',
                        },
                    },
                    manufacturingTime: {
                        base: 'statisticsOperationGoodsManufacturingTime',
                        excel: 'statisticsOperationGoodsManufacturingTimeExcel',
                    },
                    operationRecord: {
                        base: 'statisticsOperationGoodsOperationRecord',
                        excel: 'statisticsOperationGoodsOperationRecordExcel',
                    }
                },
                meal: {
                    operationTime: {
                        current: 'statisticsOperationMealOpTimeCurrent',
                        period: 'statisticsOperationMealOpTimePeriod',
                    },
                    course: {
                        current: 'statisticsOperationMealCourseCurrent',
                        period: 'statisticsOperationMealCoursePeriod',
                    },
                    timeSalesTrend: {
                        current: 'statisticsOperationMealTimeSalesTrendCurrent',
                        period: 'statisticsOperationMealTimeSalesTrendPeriod',
                        excel: 'statisticsOperationMealTimeSalesTrendExcel',
                    },
                    companySalesTrend: {
                        // current: 'statisticsOperationMealCompanySalesTrendCurrent', -> timeSalesTrend와 동일한 API (request만 틀림)
                        // period: 'statisticsOperationMealCompanySalesTrendPeriod', -> timeSalesTrend와 동일한 API (request만 틀림)
                        excel: 'statisticsOperationMealCompanySalesTrendExcel',
                    },
                    operationRecord: {
                        base: 'statisticsOperationMealOperationRecord',
                        excel: 'statisticsOperationMealOperationRecordExcel',
                    }
                }
            },
            brand: {
                goods: {
                    shop: 'statisticsBrandGoodsShop',
                    company: {
                        base: 'statisticsBrandGoodsCompany',
                        bar: 'statisticsBrandGoodsCompanyBar'
                    },
                    customer: 'statisticsBrandGoodsCustomer'
                },
                meal: {
                    shop: 'statisticsBrandMealShop',
                    company: {
                        base: 'statisticsBrandMealCompany',
                        bar: 'statisticsBrandMealCompanyBar'
                    },
                    customer: 'statisticsBrandMealCustomer'
                },
                user: 'statisticsBrandUser'
            }
        },
        dashboard: {
            cafe: {
                manual: 'dashboardCafeManualCall',
                operation: 'dashboardCafeOperationCall',
                notice: 'dashboardCafeNoticeCall',
                orderByTime: 'dashboardCafeOrderByTimeCall',
                device: 'dashboardCafeDeviceCall'
            },
            dining: {
                shopState: 'dashboardDiningShopStateCall',
                operation: 'dashboardDiningOperationCall',
                courseStatus: 'dashboardDiningCourseStatusCall',
                orderByTime: 'dashboardDiningOrderByTimeCall',
                device: 'dashboardDiningDeviceCall',
                manual: 'dashboardDiningManualCall',
                notice: 'dashboardDiningNoticeCall',
            },
            brand: {
                usageCompany: 'dashboardBrandUsageCompanyCall',
                notice: 'dashboardBrandNoticeCall',
                manual: 'dashboardManualNoticeCall',
                usageShop: 'dashboardUsageShopCall',
                registered: '/dashboardRegisteredUserCall',
                graph: '/dashboardGraphCall',
            }
        },
        reward: {
            point: {
                setting: 'rewardPointSettingCall',
                customer: {
                    base: 'rewardPointCustomerListCall',
                    history: {
                        base: 'rewardPointCustomerHistoryListCall'
                    }
                },
                log: {
                    base: 'rewardPointManualLogListCall',
                    detail: 'rewardPointManualLogDetailCall'
                },
                excel: {
                    upload: 'rewardPointManualExcelUploadCall',
                    valid: 'rewardPointManualExcelValidCall',
                    temp: 'rewardPointManualExcelTempListCall'
                }
            }
        }
    }
};
